import PropTypes from "prop-types";
import React, { useState } from "react";
import HeroAccount from "../../sections/hero-account";
import InfoPanel from "../../sections/info-panel";
import SetNewPasswordConfirmation from "../../sections/set-new-password-confirmation";
import SetNewPasswordForm from "../../sections/set-new-password-form";
import "./style.scss";
import api from "../../utils/api";
import useQuery from "../../utils/useQuery";
import { getEncryptor } from "../../services/siteService";

SetNewPassword.propTypes = {
  fields: PropTypes.object //,
  // body: PropTypes.string,
  // info: PropTypes.object,
  // setNewPasswordForm: PropTypes.object,
  // confirmationStep: PropTypes.object,
  // setNewPassword: PropTypes.func,
  // isInConfirmationStep: PropTypes.bool
};

SetNewPassword.defaultProps = {
  setNewPassword: () => {},
  isInConfirmationStep: false
};

export default function SetNewPassword({
  lang,
  fields: {
    heroAccount,
    info,
    formHeadingType,
    formHeadingBody,
    formBody,
    passwordLabel,
    passwordInfoMessage,
    passwordWarningMessage,
    passwordMissingMessage,
    ctaNamePassword,
    ctaTypePassword,
    colorSchemePassword,
    iconNamePassword,
    setPasswordFailedMessage,
    confirmHeadingType,
    confirmHeadingBody,
    confirmBody,
    ctaNameConfirm,
    ctaTypeConfirm,
    colorSchemeConfirm,
    iconNameConfirm,
    linkConfirm,
    infoPanel
  }
}) {
  const [isInConfirmationStep, setIsInConfirmationStep] = useState(false);
  const [hasServerError, setHasServerError] = useState(false);
  const query = useQuery();
  const onNewPasswordSubmitted = async (evt, data) => {
    try {
      const encryptor = await getEncryptor(query.email);
      await api.password.reset(null, {
        email: query.email,
        password: encryptor.encrypt(data.password),
        token: query.token
      });
      setIsInConfirmationStep(true);
    } catch (res) {
      setHasServerError(true);
    }
  };
  const setNewPasswordFormProps = {
    headingType: formHeadingType,
    headingBody: formHeadingBody,
    body: formBody,
    passwordLabel,
    passwordInfoMessage,
    passwordWarningMessage,
    passwordMissingMessage,
    submitButton: {
      ctaType: ctaTypePassword,
      buttonText: ctaNamePassword.value,
      colorScheme: colorSchemePassword,
      iconName: iconNamePassword
    },
    serverError: {
      hasError: hasServerError,
      message: setPasswordFailedMessage.value
    },
    submitNewPassword: (evt, data) => onNewPasswordSubmitted(evt, data)
  };
  const setNewPasswordConfirmationProps = {
    headingType: confirmHeadingType,
    headingBody: confirmHeadingBody,
    body: confirmBody,
    button: {
      buttonText: ctaNameConfirm.value,
      ctaType: ctaTypeConfirm,
      iconName: iconNameConfirm,
      colorScheme: colorSchemeConfirm,
      link: linkConfirm
    }
  };
  return (
    <div className="set-new-password grid">
      <HeroAccount {...heroAccount.fields} />
      {!isInConfirmationStep && <SetNewPasswordForm {...setNewPasswordFormProps} />}
      {isInConfirmationStep && <SetNewPasswordConfirmation {...setNewPasswordConfirmationProps} />}

      <InfoPanel {...infoPanel.fields} />
    </div>
  );
}
